import { render, staticRenderFns } from "./LegacySales.vue?vue&type=template&id=07b0cbe8&"
import script from "./LegacySales.vue?vue&type=script&lang=js&"
export * from "./LegacySales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports